import { atom, computed } from 'nanostores';
import type { AugmentedAccount, AugmentedUser, Workspace } from './types';

export const accountStore = atom<AugmentedAccount | null>(null);
export function setAccountStore(account: AugmentedAccount) {
  accountStore.set(account);
  return accountStore.get();
}

export const userStore = atom<AugmentedUser | null>(null);
export function setUserStore(user: AugmentedUser) {
  userStore.set(user);
  return userStore.get();
}

const workspaceStore = atom<Workspace[] | null>(null);
export function setWorkspaceStore(workspaces: Workspace[]) {
  workspaceStore.set(workspaces);
  return workspaceStore.get();
}

export const authStore = computed([accountStore, userStore, workspaceStore], (account, user, workspaces) => {
  return {
    account,
    user,
    workspaces,
  };
});

/**
 * Clears all authenticated account/user/workspace state. Call on a definitive
 * logout (the session `invalidated` event). `useAuth()` and the above-Pluma
 * `DerivedPermissionsProvider` read these globally now, so a signed-out
 * account's data must not linger in them. (The `invalidated` handler also
 * hard-redirects, whose full reload clears these anyway — this is belt-and-
 * suspenders and is safe because `invalidated` never fires during in-place
 * re-auth, which relies on the retained store data.)
 */
export function clearAuthStores() {
  accountStore.set(null);
  userStore.set(null);
  workspaceStore.set(null);
}
